import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-service-web',
  templateUrl: './service-web.component.html',
  styleUrls: ['./service-web.component.css']
})
export class ServiceWebComponent implements OnInit {

  //constructor(){}
  //commentted and new code added by Digvijay on 18-06-2019
  constructor(private meta: Meta,private titleService: Title) {
    this.meta.addTag({ name: 'description', content: 'Web Application Development - Our web development team uses modern javascript frameworks like angular & Microsoft tools for backend development.' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'web application development in  ny, web application development in  ph, web application development in  wc, web application development in nj, web application development in Philadelphia, web-site development ,web-application-development-in-new-york ,    web-site software development, web application development company in nj ,' },true);    
    this.titleService.setTitle('Web Application Development | Shreemon');
  }

  ngOnInit() {
  }

}
